
import axios from '../../helpers/private.axios'



export const getDocumentsFeed = () => {

    return axios.get(`/api/documents/feed`);

}